export function formatCost(value) {
  if (value == null) return '-';
  if (value === 0) return '$0.00';
  if (value < 0.0001) return '<$0.0001';
  return '$' + value.toFixed(4);
}

export function computeSpanCost(usage, pricing) {
  if (!usage || !pricing) return null;
  const inputTokens = usage.input_tokens ?? 0;
  const cachedTokens = usage.input_tokens_details?.cached_tokens ?? 0;
  const outputTokens = usage.output_tokens ?? 0;
  const uncachedInput = inputTokens - cachedTokens;
  const unit = pricing.tokensPerUnit;
  const inputCost = (uncachedInput / unit) * pricing.inputPricePerUnit;
  const cachedInputCost = (cachedTokens / unit) * pricing.cachedInputPricePerUnit;
  const outputCost = (outputTokens / unit) * pricing.outputPricePerUnit;
  const cacheSavings = (cachedTokens / unit) * (pricing.inputPricePerUnit - pricing.cachedInputPricePerUnit);
  return {
    inputCost,
    cachedInputCost,
    outputCost,
    totalCost: inputCost + cachedInputCost + outputCost,
    cacheSavings,
  };
}
